import * as _ from "lodash";
import {IComponentOptions, ILogService, IWindowService} from "angular";
import {PriorCourseUnit} from "../../model/PriorCourseUnit";
import {ApplicationService} from "../../application/application.service";
import {StateService} from "@uirouter/angularjs";

class PriorStudyUnitController {
    public item: PriorCourseUnit;
    public institution: any;
    public queue: any;
    public attachments: any;
    public applicationId: string;

    /* @ngInject */
    constructor(
        private $log: ILogService,
        private applicationService: ApplicationService,
        private toaster,
        private $state: StateService,
        private $window: IWindowService) {
    }

    public $onInit() {
        if (!this.item.supportingDocuments) {
            this.item.supportingDocuments = [];
        }

        if (!this.item.supportingLinks) {
            this.item.supportingLinks = [];
        }
        this.$log.info("PriorStudyUnitController initialised with item %o, queue %o, attachments %o",
            this.item, this.queue, this.attachments);
    }

    public unitAttachmentsOrLinksRequired() {
        this.item.hasQueuedAttachments = (this.queue && this.queue.length > 0);
        if (this.institution && this.institution.name.toUpperCase().indexOf("MONASH") !== -1) {
            return false;
        } else {
            const doesNotHaveLinks = this.item.supportingLinks.length === 0 || !_.some(this.item.supportingLinks, (link) => {
                return !_.isEmpty(_.trim(link));
            });

            return (this.item.supportingDocuments.length === 0 && this.attachments.length === 0) && doesNotHaveLinks;
        }
    }

    public isMonashInstitution() {
        return this.institution && this.institution.name.toUpperCase().indexOf("MONASH") !== -1;
    }

    public updatePriorCourseUnitCodeHandler() {
        this.applicationService.updatePriorStudiesUnitCode(this.applicationId, this.item)
            .then(() => {
                this.$log.debug("Unit code saved");
                this.toaster.pop({type: "success", title: "Unit code updated"});
                this.$window.location.reload();
            });
    }
}

export const PriorStudyUnitComponent: IComponentOptions = {
    bindings: {
        parentIndex: "<",
        index: "<",
        applicationId: "<",
        attachments: "=",
        queue: "=",
        item: "<",
        institution: "<",
        displayErrorState: "<",
        editDisabled: "<",
        currentUser: "<"
    },
    controller: PriorStudyUnitController,
    template: require("./prior-study-unit.html"),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/prior-study/unit/prior-study-unit.component.ts